import { TypeOfBankTransfer } from "@/apps/tatar/invoiceConfigApp/RACInterfaces";
import { AssetTypes } from "@/model/AssetTypes";
import { Contact } from "@/model/db/Contact";
import { ObjectId } from "@/model/db/General";
import InvoiceStruct from "@/redux/actions/struct/implemented/InvoiceStruct";
import CacheService from "@/services/CacheService";
import { FormApi } from "final-form";
import moment from "moment";
import { Invoice } from "../../../RAInterfaces";
import { RA_INVOICE_MAIN_FIELDS } from "../../../RAUtils";

class RAInvoiceFormUtilsClass {
  contactUpdated = async (
    prefix: string,
    form: FormApi<any>,
    contact: Contact,
    entity: ObjectId,
    invoice: Invoice
  ) => {
    const overwrites = contact.data.contactOverwrite?.find(
      (e) => e.entity === entity
    );

    if (overwrites) {
      const selector =
        invoice.data.direction === "INCOMING" ? "invoice" : "bill";

      if (overwrites[selector]?.category) {
        form.change(
          `${prefix || ""}${RA_INVOICE_MAIN_FIELDS().invoiceType.identifier}`,
          overwrites[selector]?.category
        );
      }
      if (overwrites[selector]?.termOfPayment) {
        form.change(
          `${prefix || ""}paymentType`,
          overwrites[selector].termOfPayment
        );

        await this.updatePaymentType(
          prefix,
          form,
          overwrites[selector].termOfPayment,
          contact._id,
          invoice
        );
      }
    }
  };

  updatePaymentType = async (
    prefix: string,
    form: FormApi<any>,
    paymentTypeId: ObjectId,
    contactId: ObjectId | undefined,
    invoice: Invoice
  ) => {
    if (paymentTypeId) {
      const paymentType = InvoiceStruct.getModeOfPayment(
        invoice.data.direction,
        paymentTypeId
      );

      if (paymentType && contactId) {
        const contact = (await CacheService.load(
          AssetTypes.Contact,
          contactId,
          true,
          false
        )) as Contact;

        if (paymentType.kind === "bankTransfer") {
          const mainBankAccount =
            contact.data.bankAccount.find((e) => e.isMain === true) ||
            contact.data.bankAccount[0];

          if (mainBankAccount) {
            if (mainBankAccount.type === "EU") {
              form.change(
                `${prefix || ""}paymentTypeData.iban`,
                mainBankAccount.iban
              );
              if (!mainBankAccount.iban.startsWith("DE")) {
                form.change(
                  `${prefix || ""}paymentTypeData.bic`,
                  mainBankAccount.bic
                );
                form.change(
                  `${prefix || ""}paymentTypeData.type`,
                  TypeOfBankTransfer.PAYMENT_IBAN_INTERNATIONAL
                );
              } else {
                form.change(
                  `${prefix || ""}paymentTypeData.type`,
                  TypeOfBankTransfer.PAYMENT_IBAN
                );
              }
            } else {
              form.change(
                `${prefix || ""}"paymentTypeData.type`,
                TypeOfBankTransfer.PAYMENT_INTERNATIONAL
              );
              form.change(
                `${prefix || ""}paymentTypeData.account`,
                mainBankAccount.accountNumber
              );
              form.change(
                `${prefix || ""}paymentTypeData.routing`,
                mainBankAccount.routingNumber
              );
              // form.change(
              //   `${prefix || ""}paymentTypeData.nameOfBank`,
              //   mainBankAccount.bankName
              // );
            }
          }

          if (!paymentType?.editable) {
            form.batch(() => {
              const currentSumAmount = _.sum(
                form.getState().values["paymentPlan"].map((e) => e.amount || 0)
              );
              const currentUsage =
                form.getState().values["paymentPlan"][0]?.usage;
              const invoiceDate =
                form.getState().values[`documentDate`] || new Date();

              const newPaymentPlan = paymentType.payments.map((payment) => {
                return {
                  amount: (currentSumAmount * payment.ratioOfPayment) / 100,
                  date: moment(invoiceDate).add(payment.daysForPayment, "days"),
                  usage: currentUsage,
                  discounts: payment.discounts || [],
                  createPaymentObject: true,
                };
              });
              form.change("paymentPlan", newPaymentPlan);
            });
          }
        } else {
          form.change(`${prefix || ""}paymentTypeData.type`, null);
        }
      }
    }
  };

  updateInvoiceDate = async (
    prefix: string,
    form: FormApi<any>,
    invoice: Invoice,
    documentDate: Date | null,
    paymentTypeId: ObjectId | undefined
  ) => {
    if (documentDate && paymentTypeId) {
      const paymentType = InvoiceStruct.getModeOfPayment(
        invoice.data.direction,
        paymentTypeId
      );

      if (
        paymentType &&
        !paymentType.editable &&
        paymentType.kind === "bankTransfer"
      ) {
        const paymentPlanOld = form.getState().values["paymentPlan"];
        const newPaymentPlan = paymentPlanOld.map((payment, index) => {
          if (payment.payedDate) {
            return payment;
          }

          return {
            ...payment,
            date:
              moment(documentDate).add(
                paymentType.payments[index]?.daysForPayment,
                "days"
              ) || payment.date,
          };
        });
        form.change("paymentPlan", newPaymentPlan);
      }
    }
  };
}
const RAInvoiceFormUtils = new RAInvoiceFormUtilsClass();
export default RAInvoiceFormUtils;
